import './ProductItem.scss'
import productImg from '../../../assets/product.svg';
import Button from '../../Atoms/Button/Button';
import { Table } from "antd";
import fetchProducts from './productJSON.json'

const columns = [
  {
    title: 'Foto',
    dataIndex: 'photo',
    key: 'photo',
  },
  {
    title: 'Nombre',
    dataIndex: 'content', 
    key: 'content',  
  },
  {
    title: 'Precio',
    dataIndex: 'price', 
    key: 'price',
  },
  {
    title: 'Acciones',
    dataIndex: 'actions', 
    key: 'actions',
  },
 ];

const ProductTable = ({ inactives }) => { 
  const productsList = []

  // Fake Fetching
  fetchProducts.products.forEach(product => 
    productsList.push({
      key: product.id,
      defaultValue: product.id,
      photo: <div className="product-item__img"><img src={product.image || productImg} alt={product.name} /></div>,
      content:  
      <>
        <div>
          <p className="source-20 bold mb-10 text-ellipsis">{product.name} {inactives && 'Inactivo'} </p>
          <p className="source-16 mb-10 text-ellipsis"><span className="source-16 bold">Descripción</span>: {product.description} </p>
        </div>
        <div className="product-item__buttons">
          {
            product.services.map((service, key) => <Button key={key} content={service} type="primary" customClass="s-large m-auto round"/>)
          }
        </div>
      </>,
      price: `USD$ ${product.price}`,
      actions: <Button small content="Editar" customClass="s-large m-auto" type="primary outline" />
    },)
  )

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
  };

  return (
    <div className="table-container">
      <Table 
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }} 
        columns={columns} 
        dataSource={productsList}
        pagination={false}
      />
    </div>
  )
}
export default ProductTable
